'use client'

import { useQueryResults } from "@/hooks/useQueryResults"
import { useMemo, useState } from "react"
import { AreaChart } from "./charts/area-chart"
import { DatasetAreaChart, DatasetSource } from "./charts/dataset-area-chart"
import moment from "moment"
import { number } from "echarts"
import { Button } from "./ui/button"
import { Percent, Sigma } from "lucide-react"

export function InactiveMKR() {
    const { results } = useQueryResults({id: 6543887})
    const [showPct, setShowPct] = useState(false)

    const formatter = new Intl.NumberFormat("en", {notation: "compact"})
    const tooltipFormatter = new Intl.NumberFormat("en", {maximumFractionDigits: 0})
    const percentFormatter = new Intl.NumberFormat("en", {style: 'percent', maximumFractionDigits: 2})

    const formattedData = useMemo(() => {
        const ds = results.reduce((acc, el) => {
            if (acc[el.date.format('YYYY-MM-DD')]) {
                acc[el.date.format('YYYY-MM-DD')][el.category] = el.balance as number
            } else {
                acc[el.date.format('YYYY-MM-DD')] = {
                    [el.category as string]: el.balance as number
                }
            }

            return acc
        }, {} as Record<string, Record<string, number>>)


        return {
            dimensions: ['date', 'active', 'inactive'],
            source: Object.entries(ds).map(([d, r]) =>
                [moment.utc(d).toDate(), r['Active'], r['Inactive']]
            )
        }
    }, [results])

    const pctData = useMemo(() => {
        return {
            dimensions: formattedData.dimensions,
            source: formattedData.source.map(s => {
                const sum = s.slice(1).reduce((a, i) => (a as number) + (i as number), 0) as number
                return [s[0], ...s.slice(1).map(v => (v as number)/sum)]
            }).filter(s => !Number.isNaN(s[1]))
        }
    }, [formattedData])

    const _switch = () => setShowPct(!showPct)

    return <div className='w-full h-[40vh] flex flex-col grow'>
        <DatasetAreaChart
            dataset={showPct?pctData:formattedData}
            title="Inactive MKR"
            description="MKR amount in addresses that have not transacted in the prior 365 days"
            stack
            stackOrder="seriesAsc"
            yAxisFormatter={(n) => showPct?percentFormatter.format(n):formatter.format(n)}
            tooltip={{
                seriesValueFormatter: (value) => showPct?percentFormatter.format(value):`${tooltipFormatter.format(value)} MKR`
            }}
            showTotal={!showPct}
            legendActions={[
                {
                    name: `Switch to ${showPct?'nominal':'percent'} view`,
                    action: _switch,
                    icon: showPct?Sigma:Percent
                }
            ]}
        />
        
    </div>
}